import * as React from "react";

const Hero = ({data}) => {
    return (
        <div>
            <div className="row-fluid-wrapper row-depth-1 row-number-1 ">
                <div className="row-fluid ">
                    <div className="span12 widget-span widget-type-custom_widget section--hero--mobile" data-widget-type="custom_widget" data-x="0" data-w="12">
                        <div id="hs_cos_wrapper_module_15771246189151132" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module" data-hs-cos-general-type="widget" data-hs-cos-type="module">
                            <img src={data.image.publicUrl} style={{ width: "100%", display: "block", margin: "0px auto" }} />
                        </div>

                    </div>
                </div>
            </div>
            <div className="row-fluid-wrapper row-depth-1 row-number-2 ">
                <div className="row-fluid ">
                    <div className="span12 widget-span widget-type-cell section--hero" style={{ backgroundImage: "url('"+data.image.publicUrl+"')" }} data-widget-type="cell" data-x="0" data-w="12">

                        <div className="row-fluid-wrapper row-depth-1 row-number-3 ">
                            <div className="row-fluid ">
                                <div className="span12 widget-span widget-type-custom_widget hero--title" data-widget-type="custom_widget" data-x="0" data-w="12">
                                    <div id="hs_cos_wrapper_module_15559047407452872" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module widget-type-rich_text" data-hs-cos-general-type="widget" data-hs-cos-type="module"><span id="hs_cos_wrapper_module_15559047407452872_" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_rich_text" data-hs-cos-general-type="widget" data-hs-cos-type="rich_text"><h1 style={{ textAlign: "right" }} dangerouslySetInnerHTML={{__html: data.text}}></h1></span></div>

                                </div>
                            </div>
                        </div>

                        <div className="row-fluid-wrapper row-depth-1 row-number-4 ">
                            <div className="row-fluid ">
                                <div className="span12 widget-span widget-type-cell container" data-widget-type="cell" data-x="0" data-w="12">

                                    <div className="row-fluid-wrapper row-depth-1 row-number-5 ">
                                        <div className="row-fluid ">
                                            <div className="span12 widget-span widget-type-cell hero--content" data-widget-type="cell" data-x="0" data-w="12">

                                                <div className="row-fluid-wrapper row-depth-1 row-number-6 ">
                                                    <div className="row-fluid ">
                                                        <div className="span12 widget-span widget-type-custom_widget " data-widget-type="custom_widget" data-x="0" data-w="12">
                                                            <div id="hs_cos_wrapper_module_15559045635902767" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module widget-type-rich_text" data-hs-cos-general-type="widget" data-hs-cos-type="module"><span id="hs_cos_wrapper_module_15559045635902767_" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_rich_text" data-hs-cos-general-type="widget" data-hs-cos-type="rich_text">
                                                                <div dangerouslySetInnerHTML={{__html: data.tagline}}></div>
                                                                </span></div>

                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Hero;